var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSales(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ventas_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 34,
    height: 34,
    transform: "translate(646 129)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    transform: "translate(-646 -129)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(-92 0.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M26.2,89.918a2.47,2.47,0,0,0-3.072-.939c-.391.171-.774.362-1.161.544l-2.791,1.317c-.034-.045-.06-.073-.08-.105A3.113,3.113,0,0,0,16.352,89.2c-.9-.017-1.808-.07-2.712-.066a5.935,5.935,0,0,1-2.821-.7,5.968,5.968,0,0,0-4.477-.414c-.417.116-.819.285-1.235.432,0-.184-.006-.366,0-.547.022-.556-.124-.718-.684-.733Q2.659,87.131.9,87.091c-.482-.012-.644.148-.657.637q-.1,3.647-.194,7.293c0,.144-.029.287-.045.431v.759a.586.586,0,0,0,.532.385c1.283.031,2.566.067,3.85.094.271.006.49-.153.473-.412-.029-.446.235-.607.567-.75a3.278,3.278,0,0,0,.36-.192A1.852,1.852,0,0,1,7.3,95.159c1.213.348,2.426.7,3.645,1.023a29.8,29.8,0,0,0,3.022.737,4.966,4.966,0,0,0,3.439-.625c2.9-1.812,5.755-3.7,8.626-5.56a.512.512,0,0,0,.171-.816M3.912,95.645H1c.07-2.543.139-5.035.207-7.513H4.118c-.07,2.539-.138,5.031-.206,7.513m20.294-4.9c-2.374,1.537-4.738,3.088-7.126,4.6a4.352,4.352,0,0,1-3.174.574c-1.141-.211-2.255-.573-3.379-.878q-1.447-.394-2.887-.812a2.879,2.879,0,0,0-2.386.273c-.089.053-.186.092-.3.147,0-.409-.007-.778,0-1.146.029-1.186.07-2.372.09-3.559a.464.464,0,0,1,.279-.452,5.279,5.279,0,0,1,5.032-.2,6.29,6.29,0,0,0,2.39.776c.709.03,1.419.042,2.128.064.573.017,1.147.026,1.72.058a2.08,2.08,0,0,1,1.888,1.691c-.117,0-.23,0-.344,0l-4.724-.126a1.238,1.238,0,0,0-.319.014.448.448,0,0,0-.364.466.442.442,0,0,0,.365.464,2.725,2.725,0,0,0,.493.039c1.74.048,3.48.081,5.219.146.634.024.8-.3.708-.8-.046-.259.043-.35.259-.45,1.216-.563,2.423-1.144,3.635-1.715a1.43,1.43,0,0,1,1.689.24c-.3.2-.6.393-.9.586",
    transform: "translate(741.621 59.435)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M48.253,14.205A7.1,7.1,0,1,0,41.16,7.087a7.108,7.108,0,0,0,7.093,7.118M48.288.98a6.125,6.125,0,1,1-6.145,6.128A6.121,6.121,0,0,1,48.288.98",
    transform: "translate(706.83 133.049)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M75.709,23.3a1.1,1.1,0,0,1-1.145-1.042c-.034-.363-.247-.578-.543-.547a.521.521,0,0,0-.436.644,1.987,1.987,0,0,0,1.133,1.686c.3.144.466.287.415.635a.379.379,0,0,0,.1.316.93.93,0,0,0,.512.165.375.375,0,0,0,.341-.437c-.048-.369.119-.5.443-.631A2.044,2.044,0,0,0,77.758,22a2.1,2.1,0,0,0-1.681-1.856c-.19-.035-.388-.032-.58-.061a1.092,1.092,0,0,1-.934-1.1,1.11,1.11,0,0,1,2.22-.042c.032.344.242.559.526.536a.509.509,0,0,0,.454-.6A2.024,2.024,0,0,0,76.4,17.047c-.242-.091-.356-.194-.31-.45a.5.5,0,0,0,0-.145.48.48,0,0,0-.953-.032.833.833,0,0,0-.012.232.356.356,0,0,1-.269.428,1.968,1.968,0,0,0-1.265,1.746,2.011,2.011,0,0,0,.938,1.918A2.638,2.638,0,0,0,75.8,21.1a1.085,1.085,0,0,1,.98,1.171A1.1,1.1,0,0,1,75.709,23.3",
    transform: "translate(679.428 119.517)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSales);
export default __webpack_public_path__ + "static/media/icon_sales.4c8dbdaacd5f786fac8ff9e3283044ce.svg";
export { ForwardRef as ReactComponent };